module.exports = __webpack_public_path__ + "img/mission_info_grid_claim_clear.460b3ba8.png";